import { MaterialEnum } from './types';

export const materialTypeHash = {
  [MaterialEnum.FILE]: 'Файл',
  [MaterialEnum.URL]: 'Ссылка',
};
